import { render, staticRenderFns } from "./NoneHome.vue?vue&type=template&id=6f22d6da&"
import script from "./NoneHome.vue?vue&type=script&lang=js&"
export * from "./NoneHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports